module.exports = __webpack_public_path__ + "img/icon_dragdrop_es.359809c.svg";